import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const BankActionPropertyModal = ({ open, onClose, data }) => {
  if (!data) return null;

  const Row = ({ label, value }) => (
    <Typography sx={{ mb: 1, fontSize: "16px" }}>
      <strong>{label}:</strong> {value || "-"}
    </Typography>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {/* TITLE */}
      <DialogTitle
        sx={{
          fontSize: "22px",
          fontWeight: "bold",
          borderBottom: "1px solid #ddd",
          mb: 1,
        }}
      >
        Property Details
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers sx={{ background: "#fff" }}>
        <Box sx={{ p: 1 }}>
          <Row label="Bank Name" value={data.bank_name} />
          <Row label="Property Type" value={data.property_type} />
          <Row label="Action Type" value={data.action_type} />
          <Row label="Location" value={data.location} />
          <Row label="City/Town" value={data.city_town} />
          <Row label="Area Town" value={data.area_town} />
          <Row label="Area" value={data.area} />
          <Row label="Units" value={data.units} />
          <Row label="Possession" value={data.possession} />
          <Row label="Possession Status" value={data.possession_status} />
          <Row label="Reserve Price" value={`₹${data.reserve_price}`} />
          <Row label="EMD Amount" value={`₹${data.emd_amount}`} />
          <Row label="Bid Increment" value={data.bid_increment} />

          <Row
            label="EMD Submission"
            value={
              data.emd_submission
                ? new Date(data.emd_submission).toLocaleString()
                : "-"
            }
          />

          <Row
            label="Auction Start"
            value={
              data.auction_start_datetime
                ? new Date(data.auction_start_datetime).toLocaleString()
                : "-"
            }
          />

          <Row
            label="Auction End"
            value={
              data.auction_end_datetime
                ? new Date(data.auction_end_datetime).toLocaleString()
                : "-"
            }
          />

          <Row label="Contact Details" value={data.bank_contact_details} />

          <Row label="Description" value={data.description} />

          <Row
            label="Download Auction File"
            value={
              data.download_auction_file ? (
                <a
                  href={data.download_auction_file}
                  style={{ color: "blue", fontWeight: "bold" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click Here
                </a>
              ) : (
                "No File"
              )
            }
          />
        </Box>
      </DialogContent>

      {/* FOOTER BUTTON */}
      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button onClick={onClose} sx={{ color: "#1976d2", fontWeight: "bold" }}>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BankActionPropertyModal;
